import { API } from "../api";

const BASE_URL = "/members/eminutes";

const memberEminutesExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberEminutes: builder.query({
      query: ({ page = 1, limit = 20 } = {}) =>
        `${BASE_URL}?guard=member&page=${page}&limit=${limit}`,
      transformResponse: (responseData) => responseData?.data ?? responseData,
      providesTags: (result) => {
        if (!result?.eminutes) return [{ type: "MemberEminute", id: "LIST" }];
        return [
          { type: "MemberEminute", id: "LIST" },
          ...(result.eminutes?.map(({ id }) => ({ type: "MemberEminute", id })) ?? []),
        ];
      },
    }),
    getMemberEminuteById: builder.query({
      query: (id) => `${BASE_URL}/${id}?guard=member`,
      transformResponse: (responseData) => responseData?.data ?? responseData,
      providesTags: (result, error, arg) => [{ type: "MemberEminute", id: arg }],
    }),
  }),
});

export const {
  useGetMemberEminutesQuery,
  useGetMemberEminuteByIdQuery,
} = memberEminutesExtendedApi;
